import {
  Combobox,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
  ComboboxPopup,
} from '~/components/ui/combobox'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type ComboboxFieldProps<TValue> = Omit<FieldProps, 'children' | 'error' | 'id'> & {
  items: { label: React.ReactNode; value: TValue }[]
  emptyLabel?: string
  placeholder?: string
  readonly?: boolean
}

export function ComboboxField<TValue>({
  label,
  optional,
  required,
  className,
  items,
  labelClassName,
  emptyLabel,
  placeholder,
  readonly,
}: ComboboxFieldProps<TValue>) {
  const field = useFieldContext<TValue | null>()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message

  type Item = (typeof items)[number]
  return (
    <Field
      id={field.name}
      label={label}
      error={errorMessage}
      optional={optional}
      required={required}
      className={className}
      labelClassName={labelClassName}
    >
      <Combobox
        items={items}
        readOnly={readonly}
        onValueChange={(v) => field.handleChange(v?.value ?? null)}
        value={items.find((item) => item.value === field.state.value) ?? null}
      >
        <ComboboxInput
          placeholder={placeholder ?? 'Selectionner une option'}
          className="w-full rounded-lg"
        />

        <ComboboxPopup>
          <ComboboxEmpty>{emptyLabel ?? 'Aucune option trouvée'}</ComboboxEmpty>
          <ComboboxList>
            {(item: Item) => (
              <ComboboxItem key={`combobox-item-${item.value}`} value={item}>
                {item.label}
              </ComboboxItem>
            )}
          </ComboboxList>
        </ComboboxPopup>
      </Combobox>
    </Field>
  )
}
